import { GroupBy } from './Types';

export const groupByOptions: GroupBy[] = [
  { type: 'SaleItem', title: 'Sale Item' },
  { type: 'customer', title: 'Customer' },
  { type: 'Tag', title: 'Tag' },
];
